<script lang="ts" setup>
import AppInput from '@/components/UI/AppInput/AppInput.vue'
import { computed } from 'vue'
import { inputNumbersOnly } from '@/services/utils'

interface IProps {
  modelValue: string | number | null
  large?: boolean
  hint?: string
  label?: string
  errors?: any[]
  unformatted?: boolean
}

const props = defineProps<IProps>()
const emit = defineEmits(['update:modelValue','change'])

const computedModelValue = computed({
  get() {
    if (props.unformatted) return String(props.modelValue ?? '')

    return formatValue(props.modelValue)
  },
  set(newValue: string) {
    const rawValue = newValue.replace(/,/g, '') // убираем форматирование
    emit('update:modelValue', rawValue)
    emit('change', rawValue)
  },
})

function formatValue(val: string | number | null): string {
  if (val === null || val === undefined || val === '') return ''

  const num = Number(val)
  if (isNaN(num)) return ''

  const fixed = num.toFixed(1) // округляем до 1 знака

  const [intPart, decimalPart] = fixed.split('.')

  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return decimalPart === '0' ? formattedInt : `${formattedInt}.${decimalPart}`
}


function onInput(event: Event) {
  const target = event.target as HTMLInputElement

  const dotCount = (target.value.match(/\./g) || []).length
  if (dotCount > 1) {
    target.value = target.value.slice(0, -1)
  }
}
</script>


<template>
  <app-input
    v-model="computedModelValue"
    :large="large"
    :keypress="inputNumbersOnly"
    @input="onInput"
    :label="props.label"
    :hint="props.hint"
    :errors="props.errors"
    :maxLength="20"
  >
    <template #label>
      <slot name="label" />
    </template>
  </app-input>
</template>
